import Component from './legal-representative-page';
export default Component;
